import React from 'react';

import './AdSetPopUp.css';

const AdSetPopUp = (props) => {
  const { adset } = props;
  const getGenderName = (gender) => {
    if (gender === 0) {
      return 'Both';
    }

    return gender === 1 ? 'Male' : 'Female';
  };

  const {
    adSetName = '',
    gender = 0,
    positions = [],
    languages = [],
    devices = [],
    ageFrom = '',
    ageTo = '',
    optimizationGoal = '',
    selectedAudiences = []
  } = adset || {};

  return adset ? (
    <div>
      <ul className="adset-list-popup">
        <li>
          <b className="adset-list-title">Name:</b>
          {adSetName}
        </li>
        <li>
          <b>Publisher Positions:</b>
        </li>
        {positions && positions.length > 0 && (
          <li>
            <ul className="adset-list-popup">
              {positions.map((position) => (
                <li>{position.text}</li>
              ))}
            </ul>
          </li>
        )}
        <li>
          <b>Targeting Languages:</b>
        </li>
        {languages && languages.length > 0 && (
          <li>
            <ul className="adset-list-popup">
              {languages.map((language) => (
                <li>{language.text}</li>
              ))}
            </ul>
          </li>
        )}
        <li>
          <b className="adset-list-title">Gender:</b>
          {getGenderName(gender)}
        </li>
        <li>
          <b>Device Platforms:</b>
        </li>
        {devices && devices.length > 0 && (
          <li>
            <ul className="adset-list-popup">
              {devices.map((device) => (
                <li>{device.text}</li>
              ))}
            </ul>
          </li>
        )}
        <li>
          <b className="adset-list-title">Age Min:</b>
          {ageFrom}
        </li>
        <li>
          <b className="adset-list-title">Age Max:</b>
          {ageTo}
        </li>
        <li>
          <b className="adset-list-title">Optimization Goal:</b>
          {optimizationGoal}
        </li>
        {selectedAudiences && selectedAudiences.length > 0 && (
          <li>
            <b className="adset-list-title">Audiences:</b>
            {selectedAudiences.map((audience) => audience.text).join(',')}
          </li>
        )}
      </ul>
    </div>
  ) : null;
};

export default AdSetPopUp;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdSetPopUp.js